// private class variables
let SongManager_songIndex

class SongManager {
    static getSongInfo = songId => SongManager_songIndex[songId]

    static loadSongIndex = filename => {
        return fetch(filename)
            .then(response => response.text())
            .then(songpaths => {
                const index = {}
                songpaths.split(/[\r\n]+/).forEach((path = '') => {
                    const s = path.replace(/\/$/, '').split('/') // delete trailing '/' before splitting
                    const cate = s[2]
                    var subCate = ""
                    if(s.length > 4) {
                        subCate = s[3]
                    }
                    const name = s.pop()
                    const nameNoSpaces = name.replace(/ /g, '')
                    const filepath = `/${s.join('/')}/${name}`
                    index[nameNoSpaces] = {
                        id: nameNoSpaces,
                        filename: `${filepath}/${name}.csv`,
                        filepath: filepath,
                        title: name,
                        category: cate,
                        subcategory: subCate,
                    }
                })
                console.log('song index', index)
                SongManager_songIndex = index
                return index
            })
            .catch(error => {
                SongManager_songIndex = {}
                console.log('load song index error: ', error)
            })
    }

    static getCategories(SongManager_songIndex) {
        Object.keys(SongManager_songIndex).map(([songId, i]) => {
          console.log("songid= ", songId, "songs = ", songs)
          var category = songs[songId];
          
          var cate = category['filepath'];
          cate = cate.split('/').splice(3);
          var cats = cate.length - 1;
      
          var so = cate.join();
          console.log("catergory  == ", so, "cate count = ", cats)
        })
      }
}

export default SongManager
